export const environment = {
	production: true,
	defaultCountryId:"IND",
	defaultCountry:"India",
	//api_url:"http://ec2-13-234-59-249.ap-south-1.compute.amazonaws.com:3000",
	//api_url:"http://127.0.0.1:3000", 
	api_url:"https://api.loraxgreen.com",
	cdn_url_home:"https://home-images.loraxgreen.com",
	cdn_url_home_json:"https://home-json.loraxgreen.com",
	cdn_url_products:"https://summary-images.loraxgreen.com",
	cdn_url_products_json:"https://summary-json.loraxgreen.com",
	R2endpoint: 'https://c3e28d6d0c8fad719729c97adac6b2cc.r2.cloudflarestorage.com',
	R2accessKeyId: '356c3c164b447a3a3a04402363f14437',
	R2secretAccessKey: '0eb719fcfc8468a7a813811386e509a4807868677890807f9aa77e66003348d2',
	R2SummaryImages:"https://summary-images.loraxgreen.com",
	R2Details:"https://details.loraxgreen.com",
	R2Home:"https://home-images.loraxgreen.com"
};
